import { main } from '@/api/main'

const state = {
  manShu:{}, // 曼殊
  liXiu:{}, // 立秀
  haoTong:{}, // 赫同
  meiTi:{}, // 美替
  aiNose:{}, // ainose
}

const mutations = {
  SET_MANSHU(state, manShu){
    state.manShu = manShu
  },
  SET_LIXIU(state, liXiu){
    state.liXiu = liXiu
  },
  SET_HaoTong(state, haoTong){
    state.haoTong = haoTong
  },
  SET_MEITI(state, meiTi){
    state.meiTi = meiTi
  },
  SET_AINOSE(state, aiNose){
    state.aiNose = aiNose
  },
}

const actions = {
  mainMessage ({ commit }) {
    return new Promise((resolve, reject) => {
      main().then((res) => {
        commit('SET_MANSHU', res.ManShu)
        commit('SET_LIXIU', res.LiXiu)
        commit('SET_HaoTong', res.HaoTong)
        commit('SET_MEITI', res.MeiTi)
        commit('SET_AINOSE', res.AINOSE)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
